module.exports = __webpack_public_path__ + "static/img/swiper_star.786e0432.svg";